import { Component } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core'

@Component({
  selector: 'formly-field-input',
  standalone: true,
  imports: [FormlyModule, ReactiveFormsModule],
  templateUrl: './input-field-type.component.html',
})
export class InputFieldTypeComponent extends FieldType<FieldTypeConfig> {}
